// PAQUETES
import axios from "axios";
import { eventoLoginAttempt } from "../../funcionesDatos/eventoPropio";



function SincronizarGoogle(props) {

    const { usuario, referidoPor, aceptaMarketing, returnTo } = props;


    async function sincronizarGoogle(event) {
        event.preventDefault();

        // Solo es un intento de LOGIN cuando viene del formulario de inicio de sesión — los demás
        // usos de este botón (sincronizar cuenta ya logueada desde "Mi cuenta") no son login.
        if (usuario === "desdeInicio") eventoLoginAttempt({ metodo: "google" });

        try {
            const respuesta = await axios.post("/obtener-entorno");
            const { entorno, urlEntorno } = respuesta.data;

            const params = new URLSearchParams({
                usuario:         usuario || "NA",
                referidoPor:     referidoPor || "NA",
                aceptaMarketing: aceptaMarketing ? "true" : "false",
                // páginas a las que se debe volver tras autenticar (ej. reservar, pagar)
                returnTo:        returnTo || "NA",
            });

            window.location.href = urlEntorno + "/auth/google?" + params.toString();
        }
        catch (error) {
            console.error("Error al obtener el entorno:", error);
            alert("Hubo un problema al sincronizar con Google.");
        }
    }


    return(
        <div>
            <button onClick={sincronizarGoogle} className="btn btn-danger me-2 d-flex justify-content-center align-items-center w-100">
                <i className="bi bi-google me-2 "></i>
                {  (usuario==="desdeInicio") ? "Iniciar con google" : "Sincronizar Google"}
            </button>
        </div>
    );
}

export default SincronizarGoogle;
